module.exports = __webpack_public_path__ + "static/incard3-bfee478d146b11dec1fba29fba1735e2.png";